import { useQuery } from '@apollo/client/react';
import type { AisExportType } from '../graphql/generated/graphql.ts';
import { DOCTOR_AIS_EXPORT_TYPES_QUERY } from './useDoctorAisExportTypes.gql';

export const useDoctorAisExportTypes = (doctorId: string, skip = false): AisExportType[] => {
  const { data } = useQuery(DOCTOR_AIS_EXPORT_TYPES_QUERY, {
    variables: {
      id: doctorId,
    },
    fetchPolicy: 'cache-and-network',
    skip,
  });

  return data?.doctor?.aisExportTypes ?? [];
};
